module.exports = __webpack_public_path__ + "img/logo.2b4b58c1.png";